export const GET_SHARED_GRADE_FEES = 'GET_SHARED_GRADE_FEES';
export const GET_STUDENT_PAYMENT_PER_FEES_TYPE_CATEGORY = 'GET_STUDENT_PAYMENT_PER_FEES_TYPE_CATEGORY'